/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputSignalGroupRequest
 */
export interface InputSignalGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof InputSignalGroupRequest
     */
    name: string;
}

/**
 * Check if a given object implements the InputSignalGroupRequest interface.
 */
export function instanceOfInputSignalGroupRequest(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputSignalGroupRequestFromJSON(json: any): InputSignalGroupRequest {
    return InputSignalGroupRequestFromJSONTyped(json, false);
}

export function InputSignalGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputSignalGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function InputSignalGroupRequestToJSON(value?: InputSignalGroupRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

